module.exports = __webpack_public_path__ + "static/media/diy_skyminer_41.833f2d5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/diy_skyminer_41.jpg
// module id = 1483
// module chunks = 0